import { render } from "./SignUpForm.vue?vue&type=template&id=142f6612"
import script from "./SignUpForm.js?vue&type=script&lang=js"
export * from "./SignUpForm.js?vue&type=script&lang=js"

import "./SignUpForm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__